import { useState, useEffect } from "react";
import { MdVerified, MdLockPerson, MdVerifiedUser, MdArrowForward } from "react-icons/md";
import logolight from "../../assets/Netraa Logo Transparent.png"
import logodark from "../../assets/Netraa Logo Dark.png"
import logofooter from "../../assets/Apmosys Products Transparent logo.png"
import { ArrowLeftIcon, ArrowRightIcon } from "@heroicons/react/24/outline";
import { useNavigate } from 'react-router-dom';
import { SiGooglemeet } from "react-icons/si";
import logo from "../../assets/Netraa_AI_OPS_Assistant_Presentation_Deck__4_-removebg-preview.png"

const timeSlots = [
  "09:00 AM","09:30 AM","10:00 AM","10:30 AM","11:00 AM","11:30 AM",
  "12:00 PM","12:30 PM","01:00 PM","01:30 PM","02:00 PM","02:30 PM",
  "03:00 PM","03:30 PM","04:00 PM","04:30 PM","05:00 PM","05:30 PM","06:00 PM"
];


export default function Demo() {
  const [darkMode, setDarkMode] = useState(false);
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState();
  const today = new Date();
  const [currentMonth, setCurrentMonth] = useState(
    new Date(today.getFullYear(), today.getMonth(), 1)
  );
  const [selectedDate, setSelectedDate] = useState(today);
  const [selectedSlot, setSelectedSlot] = useState("11:00 AM");
  const [duration, setDuration] = useState(60);
  const [focus, setFocus] = useState([]);

  const daysInMonth = new Date(
    currentMonth.getFullYear(),
    currentMonth.getMonth() + 1,
    0
  ).getDate();

  const firstDayIndex = new Date(
    currentMonth.getFullYear(),
    currentMonth.getMonth(),
    1
  ).getDay();

  const prevMonthDays = new Date(
    currentMonth.getFullYear(),
    currentMonth.getMonth(),
    0
  ).getDate();

  const changeMonth = (dir) => {
    setCurrentMonth(
      new Date(
        currentMonth.getFullYear(),
        currentMonth.getMonth() + dir,
        1
      )
    );
  };

  const isPastDay = (day) => {
    const date = new Date(
      currentMonth.getFullYear(),
      currentMonth.getMonth(),
      day
    );
    return date < new Date(today.setHours(0, 0, 0, 0));
  };

  const formatSummaryDate = () => {
    if (!selectedDate) return "";
    return selectedDate.toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
    });
  };

  const handleFocusChange = (item) => {
    setFocus((prev) =>
      prev.includes(item)
        ? prev.filter((f) => f !== item)
        : [...prev, item]
    );
  };

  const monthLabel = currentMonth.toLocaleDateString("en-US", {
    month: "long",
    year: "numeric",
  });

  const calendarDays = [];

  // Previous month filler
  for (let i = firstDayIndex - 1; i >= 0; i--) {
    calendarDays.push(
      <button
        key={`prev-${i}`}
        className="w-8 h-8 rounded-full flex items-center justify-center text-gray-300 dark:text-gray-600 cursor-not-allowed"
        disabled
      >
        {prevMonthDays - i}
      </button>
    );
  }

  // Current month days
  for (let day = 1; day <= daysInMonth; day++) {
    const isSelected =
      selectedDate &&
      selectedDate.getDate() === day &&
      selectedDate.getMonth() === currentMonth.getMonth() &&
      selectedDate.getFullYear() === currentMonth.getFullYear();

    calendarDays.push(
      <button
        key={day}
        disabled={isPastDay(day)}
        onClick={() =>
          setSelectedDate(
            new Date(
              currentMonth.getFullYear(),
              currentMonth.getMonth(),
              day
            )
          )
        }
        className={`w-8 h-8 rounded-full flex items-center justify-center transition-colors
        ${
          isPastDay(day)
            ? "text-gray-300 dark:text-gray-600 cursor-not-allowed"
            : isSelected
            ? "bg-primary text-white font-bold shadow-md shadow-primary/30"
            : "hover:bg-primary/20 hover:text-primary dark:hover:bg-primary/20 dark:hover:text-primary"
        }`}
      >
        {day}
      </button>
    );
  }

  useEffect(() => {
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
}, []);

// 🔥 ADD THIS BELOW
useEffect(() => {
  window.scrollTo(0, 0);
}, []);
  // Load theme from localStorage
  useEffect(() => {
    const theme = localStorage.getItem("theme") || "light";
    setDarkMode(theme === "dark");
    document.documentElement.classList.toggle("dark", theme === "dark");
  }, []);

  const toggleTheme = () => {
    setDarkMode((prev) => !prev);
    document.documentElement.classList.toggle("dark");
    localStorage.setItem("theme", darkMode ? "light" : "dark");
  };

  const back =() => {
    navigate("/");
  }
  return (
    <div className="bg-background-light dark:bg-black text-text-main dark:text-white transition-colors duration-200 font-body min-h-screen flex flex-col">
      {/* Header */}
<header className="header bg-white dark:bg-[#141414] border-b border-gray-200 dark:border-gray-800 px-2 lg:px-6">
  <div className="flex items-center justify-between h-full">

    {/* LEFT: LOGO */}
    <div className="flex items-center gap-3 w-64">
      <div className="flex items-center justify-start -ml-4"> {/* Shift left */}
        <img
          src={logolight}
          alt="Netraa Docs Light"
          className="h-24 mt-3 w-auto dark:hidden"
        />
        <img
          src={logodark}
          alt="Netraa Docs Dark"
          className="h-24 mt-3 w-auto hidden dark:block"
        />
      </div>
    </div>

    {/* RIGHT: VERSION + THEME + PROFILE */}
<div className="flex items-center gap-6 w-64 justify-end">
  
  {/* Theme Toggle */}
  <button
    onClick={toggleTheme}
    aria-label="Toggle Dark Mode"
    className="relative h-7 w-12 rounded-full bg-gray-200 dark:bg-gray-700
               border border-gray-300 dark:border-gray-600 transition"
  >
    <div className="absolute left-1 top-0.5 w-5 h-5 rounded-full bg-white shadow
                    transform transition-transform duration-300
                    dark:translate-x-5 flex items-center justify-center"></div>
  </button>

  {/* Back Button */}
<div className="relative group">
    <button
      onClick={back}
      className="p-2 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 transition"
    >
      <ArrowLeftIcon className="w-6 h-6" />
    </button>

    {/* Tooltip */}
  <span className="absolute top-full left-1/2 -translate-x-1/2 mt-1
                   px-2 py-1 text-xs rounded bg-gray-800 text-white
                   opacity-0 group-hover:opacity-100 transition pointer-events-none whitespace-nowrap">
    Back
  </span>
  </div>

</div>
  </div>
</header>

{/* Main content: left info + right form scroll together */}


{/* {hi} */}
<main className="hide-scrollbar flex-1 overflow-auto">
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full py-12 lg:py-16">

    {/* ===== CENTER TOP HEADER ===== */}
    <div className="flex flex-col items-center text-center gap-4 mt-6 mb-14">
      <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10">
        <span className="w-2 h-2 rounded-full bg-primary animate-pulse"></span>
        <span className="text-xs font-bold text-primary uppercase tracking-wider">
          Live Demo
        </span>
      </div>

      <h1 className="text-4xl lg:text-5xl font-extrabold text-text-main dark:text-white leading-[1.15] tracking-tight max-w-3xl">
  <span className="inline-flex items-center gap-2">
    Book a Personalized
    <img
      src={logo}
      alt="Netraa"
      className="h-12 w-25 object-contain -translate-y-1"
    />
    Demo
  </span>
</h1>

      <p className="text-lg text-text-muted dark:text-gray-300 leading-relaxed max-w-2xl">
      </p>
    </div>

    {/* ===== LEFT (Calendar) + RIGHT (Form) LAYOUT ===== */}
    <div className="lg:grid lg:grid-cols-12 lg:gap-16 items-start">

      {/* LEFT COLUMN — CALENDAR CARD (UNCHANGED) */}
      <div className="hide-scrollbar lg:col-span-5 flex flex-col gap-10 mb-12 lg:mb-0">
        <div className="relative bg-card-light dark:bg-black rounded-xl shadow-soft border border-border-color dark:border-white/5 p-6 flex flex-col gap-6 overflow-hidden">          <div className="absolute top-0 left-0 w-full h-1.5 bg-gradient-to-r from-primary to-orange-300"></div>
          {/* Date Picker */}
          <div className="space-y-3">
            <div className="flex items-center justify-between mb-2">
              <h3 className="text-sm font-bold text-text-main dark:text-white uppercase tracking-wider">
                Select Date
              </h3>

              <div className="flex items-center gap-2 text-sm font-medium text-text-main dark:text-white">
                <button
                  onClick={() => changeMonth(-1)}
                  className="p-1 hover:bg-gray-100 dark:hover:bg-white/10 rounded-full transition-colors"
                >
                  ‹
                </button>
                <span>{monthLabel}</span>
                <button
                  onClick={() => changeMonth(1)}
                  className="p-1 hover:bg-gray-100 dark:hover:bg-white/10 rounded-full transition-colors"
                >
                  ›
                </button>
              </div>
            </div>

            {/* Week Header (Perfectly Aligned) */}
            <div className="grid grid-cols-7 gap-2 text-xs font-medium text-text-muted dark:text-gray-400">
              {["S", "M", "T", "W", "T", "F", "S"].map((d) => (
                <div key={d} className="flex items-center justify-center h-8">
                  {d}
                </div>
              ))}
            </div>

            {/* Calendar Grid */}
            <div className="grid grid-cols-7 gap-2 text-sm text-text-main dark:text-white place-items-center">
              {calendarDays.map((day, index) => (
                <div
                  key={index}
                  className="w-9 h-9 flex items-center justify-center"
                >
                  {day}
                </div>
              ))}
            </div>
          </div>

          <div className="h-px w-full bg-border-color dark:bg-white/10"></div>

          {/* Slots */}
          <div className="space-y-3">
            <h3 className="text-sm font-bold text-text-main dark:text-white uppercase tracking-wider">
              Available Slots
            </h3>

            <div className="max-h-32 overflow-y-auto pr-1 custom-scrollbar">
              <div className="grid grid-cols-3 gap-2">
                {timeSlots.map((slot) => (
                  <button
                    key={slot}
                    onClick={() => setSelectedSlot(slot)}
                    className={`py-2 px-1 text-xs font-medium rounded border transition-all
                    ${
                      selectedSlot === slot
                        ? "border-primary text-primary bg-primary/5 dark:bg-primary/10 shadow-sm ring-1 ring-primary/50"
                        : "border-border-color hover:border-primary hover:text-primary dark:border-white/10 dark:hover:border-primary dark:hover:text-primary bg-background-light dark:bg-background-dark/30"
                    }`}
                  >
                    {slot}
                  </button>
                ))}
              </div>
            </div>
          </div>

          <div className="h-px w-full bg-border-color dark:bg-white/10"></div>

          {/* Duration */}
          <div className="space-y-3">
            <h3 className="text-sm font-bold text-text-main dark:text-white uppercase tracking-wider">
              Duration
            </h3>

            <div className="flex bg-gray-100 dark:bg-white/5 p-1 rounded-lg">
              {[30, 60].map((d) => (
                <button
                  key={d}
                  onClick={() => setDuration(d)}
                  className={`flex-1 py-1.5 text-sm rounded-md transition-all
                  ${
                    duration === d
                      ? "font-bold text-text-main bg-white dark:bg-card-dark dark:text-white shadow-sm"
                      : "text-text-muted hover:text-text-main"
                  }`}
                >
                  {d} min {d === 60 && "(Recommended)"}
                </button>
              ))}
            </div>
          </div>

          <div className="h-px w-full bg-border-color dark:bg-black"></div>

          {/* Demo Focus */}
          {/* <div className="space-y-3">
            <h3 className="text-sm font-bold text-text-main dark:text-white uppercase tracking-wider">
              Demo Focus
            </h3>

            <div className="grid grid-cols-2 gap-2">
              {["Netraa APM", "Netraa LH", "Netraa Orchestrator", "AI OPS Assistant"].map((item) => (
                <label
                  key={item}
                  className="flex items-center space-x-2 text-xs text-text-main dark:text-gray-300"
                >
                  <input
                    type="checkbox"
                    checked={focus.includes(item)}
                    onChange={() => handleFocusChange(item)}
                    className="w-4 h-4 rounded text-primary focus:ring-primary border-gray-300 dark:border-gray-600 dark:bg-background-dark/50"
                  />
                  <span>{item}</span>
                </label>
              ))}
            </div>
          </div> */}

        </div>
      </div>

      {/* RIGHT COLUMN — KEEP YOUR EXISTING FORM (NO CHANGE) */}
      <div className="hide-scrollbar mt-0 lg:col-span-7">
            {/* Right Quote Form */}
    <div className="hide-scrollbar lg:col-span-7">
      <div className="bg-card-light dark:bg-black rounded-lg shadow-soft border border-border-color dark:border-white/5 p-6 sm:p-8 lg:p-10 relative overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-1.5 bg-gradient-to-r from-primary to-orange-300"></div>

        {/* <div className="mb-8">
          <h2 className="text-2xl font-bold text-text-main dark:text-white">
            Request Enterprise Quote
          </h2>
          <p className="text-text-muted dark:text-gray-400 text-sm mt-1">
            Fill out the details below and our team will get back to you within 24 hours.
          </p>
        </div> */}

        <form className="space-y-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <InputField id="fullName" placeholder="Jane Doe" icon="person" label="Full Name" />
            <InputField id="workEmail" placeholder="jane@company.com" icon="mail" label="Work Email" type="email" />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <InputField id="companyName" placeholder="Acme Inc." icon="domain" label="Company Name" />
            <InputField id="jobTitle" placeholder="CTO" icon="badge" label="Job Title" />
          </div>

          {/* INDUSTRY DROPDOWN - DARK MODE BLACK BG (FIXED) */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-2">
              <label
                htmlFor="industry"
                className="text-sm font-semibold text-text-main dark:text-gray-200"
              >
                Industry
              </label>
              <select
                id="industry"
                defaultValue=""
                className="w-full p-4 rounded-lg border border-gray-300 dark:border-gray-600 
                bg-white dark:bg-black text-text-main dark:text-white 
                focus:ring-2 focus:ring-primary focus:border-primary 
                shadow-input transition-all outline-none
                dark:[color-scheme:dark]"
              >
                <option value="" disabled className="bg-white dark:bg-black text-black dark:text-white">
                  Select Industry
                </option>
                <option value="bfsi" className="bg-white dark:bg-black text-black dark:text-white">
                  BFSI
                </option>
                <option value="telecom" className="bg-white dark:bg-black text-black dark:text-white">
                  Telecom
                </option>
                <option value="ecommerce" className="bg-white dark:bg-black text-black dark:text-white">
                  E-commerce
                </option>
                <option value="healthcare" className="bg-white dark:bg-black text-black dark:text-white">
                  Healthcare
                </option>
                <option value="technology" className="bg-white dark:bg-black text-black dark:text-white">
                  Technology
                </option>
                <option value="manufacturing" className="bg-white dark:bg-black text-black dark:text-white">
                  Manufacturing
                </option>
              </select>
            </div>
          </div>

          <CheckboxGroup
            label="Demo Focus"
            options={[
              "Netraa APM",
              "Netraa LH",
              "Netraa Orchestrator",
              "AI OPS Assistant"
            ]}
          />

          <div className="space-y-2 pt-2">
            <label htmlFor="message" className="text-sm font-semibold text-text-main dark:text-gray-200">
              Message / Requirements
            </label>
            <textarea
              id="message"
              rows={1}
              placeholder="Tell us more about your infrastructure scale and specific needs..."
              className="w-full p-4 rounded-lg border border-gray-300 dark:border-gray-600 bg-background-light dark:bg-black text-text-main dark:text-white focus:ring-2 focus:ring-primary focus:border-primary shadow-input transition-all outline-none resize-none"
            ></textarea>
          </div>

          <div className="pt-4">
            {/* Summary */}
          <div className="mt-2 bg-gray-50 dark:bg-white/5 rounded-xl p-4 sm:p-5 flex flex-col gap-4 border border-border-color dark:border-white/5">
            <div>
              <h4 className="text-xs font-bold text-text-muted uppercase tracking-wider mb-3">
                Summary
              </h4>

              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-xl bg-gradient-to-r from-orange-500 to-red-600 flex items-center justify-center text-white shadow-lg shadow-blue-600/30">
                  <SiGooglemeet />
                </div>

                <div>
                  <h3 className="text-base font-bold text-text-main dark:text-white">
                    {duration} Minute Demo
                  </h3>
                  <p className="text-sm text-text-muted dark:text-gray-400">
                    {formatSummaryDate()}, {selectedSlot}
                  </p>
                </div>
              </div>
            </div>

            <button 
            type="button"
            onClick={() => setShowModal(true)}
            className="w-full bg-gradient-to-r from-orange-500 to-red-600 hover:from-orange-600 hover:to-red-700 text-white font-bold py-3 px-4 rounded-lg shadow-lg shadow-orange-500/30 transition-all duration-300 transform hover:-translate-y-0.5">
              Book My Demo
              <span className="block text-[10px] font-normal opacity-90 mt-0.5">
                No credit card required
              </span>
            </button>

            <p className="text-[10px] text-center text-text-muted dark:text-gray-500">
              By booking, you agree to our Terms of Service.
            </p>
          </div>


            <p className="text-xs text-center text-text-muted mt-4">
              By submitting, you agree to our{" "}
              <a href="#" className="underline hover:text-primary">Terms of Service</a> and{" "}
              <a href="#" className="underline hover:text-primary">Privacy Policy</a>.
            </p>
          </div>
        </form>
      </div>
    </div>
      </div>

    </div>
     {showModal && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
    <div className="bg-white dark:bg-gray-800 rounded-lg p-8 w-96 text-center shadow-lg relative">
      <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-4">Thank You!</h3>
      <p className="text-gray-700 dark:text-gray-300 mb-6">
        Your demo request has been submitted. Our Business Development team will contact you soon.
      </p>
      <button
        onClick={() => setShowModal(false)}
        className="px-6 py-2 bg-primary text-white rounded-lg hover:bg-primary-dark transition"
      >
        Close
      </button>
    </div>
  </div>
)}
  </div>
</main>

      {/* Footer */}
      <footer className="bg-white dark:bg-black border-t border-border-color dark:border-white/10 py-10 mt-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="flex flex-col items-center md:items-start gap-1">
            <p className="text-xs font-bold text-text-muted uppercase tracking-wider">Powered by</p>
            <div className="flex items-center gap-3 w-64">
      <div className="flex items-center justify-start -ml-4"> {/* Shift left */}
        <img
          src={logofooter}
          alt="Apmosys logo"
          className="h-10 w-auto dark:hidden"
        />
        <img
          src={logofooter}
          alt="Apmosys logo"
          className="h-10 w-auto hidden dark:block"
        />
      </div>
    </div>

          </div>
          <div className="text-sm text-text-muted text-center">
            © 2025 ApMoSys Products Private Ltd. All rights reserved.
          </div>
          <div className="flex items-center gap-6 grayscale opacity-70 hover:grayscale-0 hover:opacity-100 transition-all">
            <div className="flex flex-col items-center gap-1 group cursor-pointer">
              <MdLockPerson className="text-3xl text-text-main dark:text-white" />
              <span className="text-[10px] font-bold text-text-main dark:text-white">SOC2 Type II</span>
            </div>
            <div className="w-px h-8 bg-border-color dark:bg-white/20"></div>
            <div className="flex flex-col items-center gap-1 group cursor-pointer">
              <MdVerified className="text-3xl text-text-main dark:text-white" />
              <span className="text-[10px] font-bold text-text-main dark:text-white">ISO 27001</span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

/* --- Subcomponents --- */
function InputField({ id, placeholder, label, icon, type = "text" }) {
  return (
    <div className="space-y-2">
      <label htmlFor={id} className="text-sm font-semibold text-text-main dark:text-gray-200">{label}</label>
      <div className="relative">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-400">
          <span className="material-symbols-outlined text-[20px]">{icon}</span>
        </div>
        <input
          type={type}
          id={id}
          placeholder={placeholder}
          className="w-full pl-10 pr-4 py-3 rounded-lg border-border-color bg-background-light dark:bg-background-dark/50 text-text-main dark:text-white focus:ring-2 focus:ring-primary focus:border-primary shadow-input transition-all outline-none"
        />
      </div>
    </div>
  );
}

export function SelectField({ id, label, options, defaultValue = "" }) {
  return (
    <div className="flex flex-col gap-2">
      <label htmlFor={id} className="text-sm font-semibold">
        {label}
      </label>

      <select
        id={id}
        defaultValue={defaultValue}
        className="p-3 rounded-lg border border-border-color
                   bg-background-light dark:bg-background-dark/50
                   text-text-main dark:text-white outline-none"
      >
        {options.map((opt, idx) => (
          <option key={idx} value={opt.value} disabled={opt.disabled}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
}


function CheckboxGroup({ label, options }) {
  return (
    <div className="space-y-3 pt-2">
      <label className="text-sm font-semibold text-text-main dark:text-gray-200">{label}</label>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {options.map((opt, idx) => (
          <label key={idx} className="flex items-center space-x-3 p-3 border border-border-color dark:border-white/10 rounded-lg cursor-pointer hover:bg-gray-50 dark:hover:bg-white/5 transition-colors">
            <input type="checkbox" className="w-5 h-5 rounded text-primary focus:ring-primary border-gray-300 dark:border-gray-600 dark:bg-background-dark/50" />
            <span className="text-sm text-text-main dark:text-gray-200 font-medium">{opt}</span>
          </label>
        ))}
      </div>
    </div>
  );
}

function RadioGroup({ label, options }) {
  return (
    <div className="space-y-3 pt-2">
      <label className="text-sm font-semibold text-text-main dark:text-gray-200">{label}</label>
      <div className="flex gap-4">
        {options.map((opt, idx) => (
          <label key={idx} className="inline-flex items-center">
            <input type="radio" name="deployment" value={opt.value} className="w-5 h-5 text-primary border-gray-300 focus:ring-primary dark:bg-background-dark/50 dark:border-gray-600" />
            <span className="ml-2 text-text-main dark:text-gray-200">{opt.label}</span>
          </label>
        ))}
      </div>
    </div>
  );
}
